//TODO:: LOAD VIA WEBPACK
require('angular-off-click');
module.exports = 'offClick';



// WEBPACK FOOTER //
// ./client/app/chaps/offClick-loader.js